import { render, staticRenderFns } from "./BasicCarousel.vue?vue&type=template&id=ab8c8300&"
import script from "./BasicCarousel.vue?vue&type=script&lang=js&"
export * from "./BasicCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports